export { default } from './TasksExecsService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/services/TasksExecsService/index.js